module.exports = __webpack_public_path__ + "img/logo.da1fa5ed.png";